import { Envelope } from "@phosphor-icons/react";
import React from "react";

export default function SupportTicket() {
  return (
    <div className="w-full h-full flex justify-center pt-10 relative">
      <div className="w-full min-h-full">
        <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
          <div className="flex justify-center items-center gap-5">
            <p> All ticket 0 </p>
            <p> Answered 0 </p>
            <p> Pending 0</p>
          </div>
          <button className="bg-[#A7FF35] p-2 rounded-xl text-black w-48 flex justify-center items-center gap-5">create ticket <Envelope size={32}  /></button>
        </nav>
        <div className="border border-gray-400 p-5 rounded-bl-md rounded-br-md ">
          <div className="w-full p-4">
            <ul className="flex justify-between w-full  bg-black p-3">
              <li>TICKET ID </li>
              <li>SUBJECT </li>
              <li>TOTAL REPLY</li>
              <li>ACTION</li>
            </ul>
            <div className="p-10">
                <p className="text-center">No data found</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
